module.exports = __webpack_public_path__ + "img/layout_top_tree_right.b1ba341b.svg";